import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-technicalservice',
  templateUrl: './technicalservice.component.html',
  styleUrls: ['./technicalservice.component.css']
})
export class TechnicalserviceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/technicalservice/technicalservice.component.ts